import React, { ReactElement } from "react";
import HomeLayout from "./Layouts";
import HomeHero from "./Banner/BannerSignup";
import HomeService from "./Service";
import HomeApps from "./Apps";
import HomeWhyUs from "./WhyUs";
import HomeVideo from "./Video";
import HomeSteps from "./Steps";
import GetStarted from "./GetStarted";
import Gallery from "./Gallery";
import HomeFaq from "./Faq";

const SignUp = (): ReactElement => {
  return (
    <HomeLayout>
      <main className="">
        <HomeHero />
        <HomeService />
        <HomeApps />
        <HomeWhyUs />
        <HomeVideo />
        <HomeSteps />
        {/* <Gallery /> */}
        <GetStarted />
        <HomeFaq />
      </main>
    </HomeLayout>
  );
};

export default SignUp;
